import {
  Component,
  forwardRef,
  Input,
  ContentChildren,
  QueryList,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { DsRadioButtonComponent } from "../ds-radio-button/ds-radio-button.component";
import { Subscription } from "rxjs";

@Component({
  selector: "ds-radio-group",
  templateUrl: "./ds-radio-group.component.html",
  styleUrls: ["./ds-radio-group.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DsRadioGroupComponent),
      multi: true,
    },
  ],
})
export class DsRadioGroupComponent implements ControlValueAccessor, AfterViewInit, OnChanges, OnDestroy {
  @Input() groupName!: string;
  @Input() error: boolean = false;
  @Input() errorMessage: string = "";
  @ContentChildren(DsRadioButtonComponent) radioButtons!: QueryList<DsRadioButtonComponent>;

  value: string = "";
  private subscriptions: Subscription[] = [];

  onChange = (_: string) => {};
  onTouched = () => {};

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.setupRadioButtons();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.radioButtons && changes["error"]) {
      setTimeout(() => {
        this.radioButtons.forEach((radioButton) => {
          radioButton.error = this.error;
        });
      });
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  setupRadioButtons() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];

    this.radioButtons.forEach((radioButton) => {
      radioButton.name = this.groupName;
      radioButton.error = this.error;
      radioButton.valueChecked = this.value;

      const subscription = radioButton.selectionChange.subscribe((value) => this.onSelectionChange(value));
      this.subscriptions.push(subscription);
    });
  }

  onSelectionChange(value: string) {
    this.value = value;
    this.onTouched();

    this.onChange(value);

    this.radioButtons.forEach((radioButton) => {
      radioButton.valueChecked = value;
    });
  }

  writeValue(value: string): void {
    this.value = value;

    if (this.radioButtons) {
      setTimeout(() => {
        this.radioButtons.forEach((radioButton) => {
          radioButton.valueChecked = value;
        });
      });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
